const IST_OFFSET=19800000;
export function indiaDateKey(now=Date.now()) {return new Date(now+IST_OFFSET).toISOString().slice(0,10);}
export function nextArrival(now=Date.now()) {
 const d=new Date(now+IST_OFFSET);d.setUTCMinutes(0,0,0);d.setUTCHours(d.getUTCHours()+1);
 return {date:d.toISOString().slice(0,10),time:d.toISOString().slice(11,16)};
}
export function hourLabel(time) {
 const [h,m]=String(time||'').split(':').map(Number);
 if(!Number.isInteger(h)||h<0||h>23||!Number.isInteger(m)||m<0||m>59)return 'Select time';
 return `${String(h%12||12).padStart(2,'0')}:${String(m).padStart(2,'0')} ${h<12?'AM':'PM'}`;
}
export function dateLabel(date) {
 const d=new Date(`${date}T12:00:00+05:30`);
 return Number.isNaN(d.getTime())?'Select date':d.toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric',timeZone:'Asia/Kolkata'});
}
export function calendarDays(month) {
 const [y,m]=month.split('-').map(Number),first=new Date(Date.UTC(y,m-1,1)),days=new Date(Date.UTC(y,m,0)).getUTCDate();
 return [...Array(first.getUTCDay()).fill(null),...Array.from({length:days},(_,i)=>`${y}-${String(m).padStart(2,'0')}-${String(i+1).padStart(2,'0')}`)];
}
export function shiftMonth(month,offset) {
 const [y,m]=month.split('-').map(Number);return new Date(Date.UTC(y,m-1+offset,1)).toISOString().slice(0,7);
}
export function validArrival(date,time,now=Date.now()) {const start=Date.parse(`${date}T${time}:00+05:30`);return Number.isFinite(start)&&start>=now&&start<=now+180*86400000;}
export function pricePreview(original,offer,points) {
 original=Math.max(0,Number(original)||0);
 const free=Number(points)>=10;
 const discount=free?original:offer?.type==='percent'?original*(Math.min(100,Math.max(0,Number(offer.value)||0)))/100:offer?.type==='flat'?Math.max(0,Number(offer.value)||0):0;
 const roundedDiscount=Math.min(original,Math.round(discount*100)/100);
 return {original,discount:roundedDiscount,total:Math.round((original-roundedDiscount)*100)/100,free};
}
